import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { FastField } from 'formik'
import useWordings from '@v4/hooks/useWordings'
import PhoneNumber from './components/PhoneNumber'

const FormPhoneField = props => {
	const { settings, layout = 'transparent', label = '', required = false } = props
	const { ready } = useWordings('countries')

	return (
		<FastField key={`${layout}_${label}_${required}_${settings?.default_country || ''}_${ready}`} {...props}>
			{({ field, meta: { touched, error } }) => {
				const errorText = touched ? error : ''

				return (
					<PhoneNumber
						{...props}
						layout={layout}
						label={label}
						required={required}
						{...field}
						error={!!errorText && touched}
						helperText={errorText}
					/>
				)
			}}
		</FastField>
	)
}

FormPhoneField.propTypes = {
	name: PropTypes.string.isRequired,
	// eslint-disable-next-line react/no-unused-prop-types
	usePaperColors: PropTypes.bool,
	label: PropTypes.string,
	required: PropTypes.bool,
	layout: PropTypes.string,
	settings: PropTypes.object,
}

export default memo(FormPhoneField)
